import { render, staticRenderFns } from "./AdVideos.vue?vue&type=template&id=4bfd6c1b"
import script from "./AdVideos.vue?vue&type=script&lang=js"
export * from "./AdVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports